import { z } from "zod";
import { Url } from "./base";
export const FEEDBACK_MEDIA_UPLOAD_FIELD = "media";
export const FEEDBACK_MEDIA_MAX_FILES = 4;
export const FEEDBACK_MEDIA_IMAGE_MAX_BYTES = 5 * 1024 * 1024; // 5 MB
export const FEEDBACK_MEDIA_VIDEO_MAX_BYTES = 30 * 1024 * 1024; // 30 MB
export const feedbackCategoryValues = [
    "bug",
    "feature",
    "improvement",
    "other",
    "report-community",
];
export const FeedbackCategorySchema = z.enum(feedbackCategoryValues);
export const FeedbackMediaAttachmentSchema = z.object({
    type: z.enum(["image", "video"]),
    name: z.string(),
    size: z.number().nonnegative(),
    sizeFormatted: z.string(),
    url: Url,
});
export const FeedbackSubmissionRequestSchema = z.object({
    category: FeedbackCategorySchema,
    message: z.string().min(1).max(4096),
    projectName: z
        .string()
        .max(256)
        .optional()
        .transform((value) => value?.trim() || undefined),
    mediaAttachments: FeedbackMediaAttachmentSchema.array()
        .max(FEEDBACK_MEDIA_MAX_FILES)
        .optional()
        .default([]),
});
export const FeedbackRecordSchema = FeedbackSubmissionRequestSchema.extend({
    id: z.number(),
    userId: z.string(),
    userName: z.string().nullable().optional(),
    hasMedia: z.boolean(),
    timestamp: z.string(),
});
